module.exports = __webpack_public_path__ + "img/Handle.1f3cd9cb.png";